var columnSettings = {
  name: {
    class: 'tablesort-sortable',
    name: 'name',
    displayName: 'NUMBERS_NAME'
  },
  phoneNumber: {
    class: 'tablesort-sortable',
    name: 'phoneNumber',
    displayName: 'NUMBERS_NUMBER'
  },
  displayNumber: {
    class: 'tablesort-sortable',
    name: 'displayNumber',
    displayName: 'NUMBERS_FORMATTED',
    hide: true,
  },
  allocationDT: {
    class: 'tablesort-sortable',
    name: 'allocationDT',
    displayName: 'NUMBERS_ALLOCATION_DT',
    hideForUserType: ['affiliate', 'affiliate_manager'],
    defaultSort: 'desc',
  },
  nextChargeDT: {
    class: 'tablesort-sortable',
    name: 'nextChargeDT',
    displayName: 'NUMBERS_CHARGE_DT',
    hideForUserType: ['affiliate', 'affiliate_manager']
  },
  campaignId: {
    class: 'tablesort-sortable width-20-percent',
    name: 'campaignName',
    displayName: 'NUMBERS_LINK_CAMPAIGN'
  },
  numberPoolId: {
    class: 'tablesort-sortable',
    name: 'numberPoolName',
    displayName: 'NUMBERS_LINK_POOL'
  },
  affiliate: {
    class: 'tablesort-sortable width-20-percent',
    name: 'affiliate.name',
    displayName: 'NUMBERS_LINK_PUBLISHER',
    hideForUserType: ['affiliate']
  },
  country: {
    class: 'tablesort-sortable',
    name: 'assignmentSettings.countryCode',
    displayName: 'NUMBERS_COUNTRY'
  },
  offer: {
    class: 'tablesort-sortable',
    name: 'offerName',
    displayName: 'NUMBERS_OFFER',
    hideForUserType: ['admin', 'buyer', 'buyer_manager']
  },
  status: {
    class: 'tablesort-sortable',
    name: 'enabled',
    displayName: 'STATUS_TEXT',
    rowAlign: 'center'
  }
};

var InterchangeableCountries = [
  'US',
  'CA'
];

var defaultColumns = [
  'phoneNumber',
  'country',
  'name',
  'displayNumber',
  'allocationDT',
  'nextChargeDT',
  'campaignId',
  'numberPoolId',
  'offer',
  'affiliate',
  'status'
];

var serviceBaseUriLegacy;
var promiseCacheServiceLegacy;
export default class NumberService {

  /** @ngInject **/
  constructor(
    _,
    $http,
    ngAuthSettings,
    promiseCacheService
  ) {
    this._ = _;
    this.$http = $http;
    this.ngAuthSettings = ngAuthSettings;
    this.promiseCacheService = promiseCacheService;
    this.serviceBaseUri = ngAuthSettings.apiServiceBaseUri;
    this.defaultColumns = defaultColumns;
    this.InterchangeableCountries = InterchangeableCountries;
    this.columnSettings = columnSettings;

    // Solution associated to this card
    // #10480 Investigate why user tag is not showing up and list of numbers are not being populated
    // It avoids accessing a null context('this') when it's calling "getCachedNumbers" method.
    serviceBaseUriLegacy = ngAuthSettings.apiServiceBaseUri;
    promiseCacheServiceLegacy = promiseCacheService;
  }

  getAvailableCountries(accountId) {
    const url = this.serviceBaseUri + accountId + '/numbers/availableCountries';
    return this.$http.get(url);
  }

  getNumbers(accountId) {
    const url = this.serviceBaseUri + accountId + '/numbers';
    return this.$http.get(url);
  }

  getNumbersUI(accountId) {
    const url = this.serviceBaseUri + accountId + '/numbers/UI';
    return this.$http.get(url);
  }

  getCachedNumbers(accountId) {
    const url = serviceBaseUriLegacy + accountId + '/numbers';
    return promiseCacheServiceLegacy.getCallWithCachedPromise('numbersGetPromise' + accountId, url, 30);
  }

  getNumber(accountId, numberId) {
    const url = this.#serviceBaseUrl(accountId, numberId);
    return this.$http.get(url);
  }

  createNumber(accountId, assignmentSettings) {
    const url = this.serviceBaseUri + accountId + '/numbers';
    return this.$http.post(url, assignmentSettings);
  }

  attachAffiliate(accountId, numberId, affiliateId) {
    const url = this.#serviceBaseUrl(accountId, numberId) + '/affiliate';
    return this.$http.put(url, { affiliateId: affiliateId });
  }

  removeAffiliate(accountId, numberId, affiliateId) {
    const url = this.#serviceBaseUrl(accountId, numberId) + '/affiliate/' + affiliateId;
    return this.$http.delete(url);
  }

  getNumberReferences(accountId, numberId) {
    const url = this.#serviceBaseUrl(accountId, numberId) + '/InboundReferences';
    return this.$http.get(url);
  }

  deleteNumber(accountId, numberId, unlink) {
    const url = this.#serviceBaseUrl(accountId, numberId) + '?unlink=' + unlink;
    return this.$http.delete(url);
  }

  updateNumber(accountId, numberId, updatedParams) {
    const update = {};

    update.enabled = updatedParams ? updatedParams.enabled : undefined;

    if (updatedParams && updatedParams.name !== undefined) {
      update.name = updatedParams.name;
    }

    if (updatedParams && updatedParams.tags) {
      update.tags = this.#removeDuplicateTags(updatedParams.tags);
    }

    const url = this.#serviceBaseUrl(accountId, numberId);
    return this.$http.patch(url, update);
  }

  getNumberOrder(accountId, orderId) {
    const url = this.#serviceNumberOrderUrl(accountId, orderId);
    return this.$http.get(url);
  }

  getNumberOrders(accountId, timeFilter) {
    let url = this.#serviceNumberOrderUrl(accountId);
    url = timeFilter ? url + '?filterRange=' + timeFilter : url;
    return this.$http.get(url);
  }

  getPendingNumberOrders(accountId) {
    const url = this.#serviceNumberOrderUrl(accountId) + 'Pending';
    return this.$http.get(url);
  }

  createNumberOrder(accountId, order) {
    const url = this.#serviceNumberOrderUrl(accountId);
    return this.$http.post(url, order);
  }

  cancelNumberOrder(accountId, orderId) {
    const url = this.#serviceNumberOrderUrl(accountId, orderId);
    return this.$http.delete(url);
  }

  isNumberEligibleForCampaignOrOffer(number, countryCodeContext, selectedAffiliate) {
    return !number.campaignId &&
      !number.numberPoolId &&
      !number.offerId &&
      this.#isNumberEligibleToAffiliate(number, selectedAffiliate) &&
      this.#isNumberCountryEligibleForCampaign(number, countryCodeContext);
  }


  #serviceBaseUrl(accountId, numberId) {
    return this.serviceBaseUri + accountId + '/numbers/' + numberId;
  }

  #serviceNumberOrderUrl(accountId, id) {
    return this.serviceBaseUri + accountId + '/numbers/orders' + (id ? '/' + id : '');
  }

  #isNumberEligibleToAffiliate(number, selectedAffiliate) {
    return (!number.affiliate || (selectedAffiliate && number.affiliate.id === selectedAffiliate.id));
  }

  #isNumberCountryEligibleForCampaign(number, campaignCountry) {
    if (number.assignmentSettings && number.assignmentSettings.countryCode) {

      if (number.assignmentSettings.countryCode.indexOf(campaignCountry) === 0) {
        return true;
      }

      if (InterchangeableCountries.includes(campaignCountry) && InterchangeableCountries.includes(number.assignmentSettings.countryCode)) {
        return true;
      }
    }

    return false;
  }

  #removeDuplicateTags(tags) {
    return this._.uniqBy(tags, (tag) => {
      return tag.tagName + ':' + tag.tagValue;
    });
  }

  #getCacheKey(accountId) {
    return 'numbersGetPromise' + accountId;
  }

}
